export const robotoFontPath =
  'https://cdn.trustedshops.com/google-fonts/roboto/';

interface Font {
  [weight: string]: {
    weight: number;
    fontFileName?: string;
    localFontName?: string;
  };
}

const fonts: Font = {
  Light: { weight: 300 },
  Regular: { weight: 400, fontFileName: 'regular', localFontName: 'Roboto' },
  Medium: { weight: 500 },
  Bold: { weight: 700 }
};

const fontFaces = ['Light', 'Regular', 'Medium', 'Bold'].map(
  (weight: string) => {
    const urls = [
      { extension: 'woff2', format: 'woff2' },
      { extension: 'woff', format: 'woff' },
      { extension: 'ttf', format: 'truetype' },
      { extension: 'svg#Roboto', format: 'svg' }
    ].map(
      ({ extension, format }) =>
        `url('${robotoFontPath}roboto-v27-latin-ext_latin-${
          fonts[weight].fontFileName || fonts[weight].weight
        }.${extension}') format('${format}')`
    );
    return `
@font-face {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: ${fonts[weight].weight};
  font-display: swap;
  src: local('${fonts[weight].localFontName || `Roboto ${weight}`}'),
       local('Roboto-${weight}'),
       ${urls.join(',\n       ')}
}`;
  }
);

export const buildRobotoFontCSS = () => fontFaces.join('\n');
